<template>
        <select id="owner_id" ref="input" class="form-control form-control-lg owner-tom-selector" name="adminsAssigned[]" multiple="" v-model="ownerId"
                placeholder="Add representative">
        </select>
</template>

<script>

import {EventBus} from "@/events/event-bus";
import TomSelect from 'tom-select'
import {getInquiryAdminUsers, inquiryAddOwnerId} from '@/modules/common/api'
import axios from "axios";

export default {
    name: "selectRepresentative",
    props: {
        currency: null,
        parent: null,
        openOnFocus: null,
        s3Path: null,
        viewPage: null,
        currentUser: null,
        currentRole: null,
        inquiryId: '',
        itemType: {
            default() {
                // can be booking or inquiry or invoice etc.
                return 'booking'
            }
        },
        selectedAssignedUsers: {
            default() {
                // can be booking or inquiry or invoice etc.
                return []
            }
        },
        selectedAssignedUsersIds: {
            default() {
                // can be booking or inquiry or invoice etc.
                return []
            }
        },
        itemId: {
            default() {
                return null
            }
        },
        value: null
    },
    data() {
        return {
            select: null,
            owners: [],
            categories: [],
            ownerId: this.value,
            currentAssignedUsers: this.selectedAssignedUsers,
            curentSelectedAssignedUsersIds: this.selectedAssignedUsersIds
        }
    },
    mounted() {
        let vm = this;
        let custom_columns_array = ['first_name', 'avatar', 'last_name', 'username', 'mobile1', 'email1', 'phone1', 'verified', 'user_id', 'created', 'active'];
        /**       getInquiryAdminUsers() ???? call API to get users owner data **/

        getInquiryAdminUsers(custom_columns_array)
            .then(response => {
                this.owners = response.data
                /** call function to add data to the booking Owner dropdown list and render HTML for it  **/

                this.initiateDropdown(this.owners)
            })
            .catch(error => {
                console.log(error)
            })
    },
    methods: {
        imgPath(avatar){
            return this.s3Path + avatar;
        },
        initiateDropdown(owners) {
            let vm = this;
            this.$nextTick(() => {
                // I added the variable to window to use it in jquery in other pages
                this.select = window.ownersSelect = new TomSelect(this.$refs['input'], {
                    preload: true,
                    labelField: 'username',
                    searchField: ['username', 'first_name', 'last_name'],
                    valueField: 'user_id',
                    highlight: false,
                    persist: false,
                    load: function (query, callback) {
                        let self = this;

                        if (self.loading > 1) {
                            callback();
                            return;
                        }

                        callback(owners)

                        self.settings.load = null;
                    },
                    openOnFocus: true,
                    render: {
                        option: function (item, escape) {
                            if (item.first_name == '') {
                                item.first_name = item.username;
                            }

                            return `<div class="col-12">
                                    <img src="${vm.s3Path}${item.avatar}" onerror="this.src='data:image/png;base64,${item.image}'" class="img-circle" alt="" width="32">
                                    <span style="margin-left: 10px">   ${escape(item.first_name)} ${escape(item.last_name)}
                                    </span>
                                    </div>`
                        },
                        item: function (data, escape) {
                            return `<div id="owner_name_${data.user_id}" class="col-12" style="background: #FFF;" onmouseover="this.style.background='#efefef';this.style.color='#000'"
                                    onmouseout="this.style.background='#FFF';this.style.color='#000'">
                                    <img src="${vm.s3Path}${data.avatar}" onerror="this.src='data:image/png;base64,${data.image}'" class="img-circle" alt="" width="30">
                                    <span style="margin-left: 10px;line-break: anywhere;font-size: 14px;color: #000">${escape(data.username)}</span>
                                </div>`
                        }
                    },
                })

                // Add current owner
                this.select.on('load', (value, item) => {
                    if (this.ownerId) {
                        this.select.addItem(this.ownerId)
                    } else if (this.currentUser && (this.currentRole != 1 && this.currentRole != 11) && (this.itemId ===null || this.itemId ==='')) {//for fieldworkers and subworkers we display first value from owners
                        this.select.addItem(this.currentUser)
                    } else if ((this.itemId ===null || this.itemId ==='')){
                        this.select.addItem(value[0].user_id);
                    }
                })


                // Add owner
                this.select.on('item_add', (value, item) => {
                    // let owner = this.owners.find(owner => owner.user_id == value)
                    document.getElementById("owner_id-ts-control").setAttribute('readonly', true);
                    if(this.viewPage){

                        let url = `/inquiry/assignRepresentative/${this.inquiryId}`;
                        let data = {adminsAssigned:[]};
                        data.inquiryId = this.inquiryId;
                        data.adminsAssigned = this.select.getValue();
                        $.ajax({
                            url: url,
                            type: 'POST',
                            data: data,
                            dataType: "json",
                            success: function(response) {
                                console.log(response);

                                // $.notify(response.message, 'success')
                            },error: function(xhr, status, error) {
                                reject(error); // Reject the promise with the error message
                            }
                        });
                    }
                })

                // remove a owner when unselect it from dropdown
                this.select.on('item_remove', (value, item) => {
                    if(this.viewPage){
                        let url = `/inquiry/assignRepresentative/${this.inquiryId}`;
                        let data = {adminsAssigned:[]};
                        data.inquiryId = this.inquiryId;
                        data.adminsAssigned = this.select.getValue();
                        $.ajax({
                            url: url,
                            type: 'POST',
                            data: data,
                            success: function(response) {
                                // $.notify(response.message, 'success')
                            },error: function(xhr, status, error) {
                                reject(error); // Reject the promise with the error message
                            }
                        });
                    }

                })

                for(const user of this.currentAssignedUsers){
                    this.select.addOption(user)
                    this.select.addItem(user.user_id)
                }
            })
        }
    },
    computed:{

    },
    watch:{
        ownerId(value){
            this.$emit('input',parseInt(value))
        },
        deep: true,
        immediate: true
    }
}
</script>

<style scoped>
.last-active{
    color: #000 !important;
    background: #dfdfdf !important;
}
</style>